import React, { useState } from 'react';
import News_item from '../../components/blog/news_item';
import { NextSeo } from 'next-seo';
import PageBanner from '@apps/components/pageBanner';
import { usePostCategoryListingQuery, usePostListingQuery, usePostTagListingQuery } from '../../graphql/api';
import { useRouter } from 'next/router';
import moment from 'moment';
import Sidebar from '@apps/components/sidebar';

const Blog = () => {
  const metaTitle = 'Blog - Alchemis';
  const metaDesc = `Stay updated with our latest news and developments`;
  const metaImg = `/images/meta/general.png`;
  let postFilter;
  const [loadMoreBtn, setLoadMoreBtn] = useState(false);
  const {
    query: {
      category,
      tag
    }
  } = useRouter();


  // Todo : if Loading do preloader
  // Todo : empty state
  if (tag) {
    postFilter = {
      filters: {
        companies: {
          slug: {
            eq: 'alchemis'
          }
        },
        post_type: {
          post_type_slug: {
            eq: 'blog'
          }
        },
        post_categories: {
          post_category_slug: {
            in: category
          }
        },
        post_tags: {
          post_tag_slug: {
            in: tag?.split(',')
          }
        }
      }
    };

  } else {
    postFilter = {
      filters: {
        companies: {
          slug: {
            eq: 'alchemis'
          }
        },
        post_type: {
          post_type_slug: {
            eq: 'blog'
          }
        },
        post_categories: {
          post_category_slug: {
            in: category
          }
        }
      }
    };
  }

  // ====================== API
  const { data: postListingData, loading } = usePostListingQuery({
    variables: {
      ...postFilter
    }
  });

  const { data: postTag } = usePostTagListingQuery({
    variables: {
      filters: {
        companies: {
          slug: {
            eq: 'alchemis'
          }
        },
      }
    }
  });

  const { data: postCategory } = usePostCategoryListingQuery({
    variables: {
      filters: {
        companies: {
          slug: {
            eq: 'alchemis'
          }
        },
      }
    }
  });

  const blog_list = (postListingData?.posts?.data?.length > 0) ? postListingData?.posts?.data.map((e) => {
    return {
      id: e.id,
      title: e?.attributes?.post_title,
      text: e?.attributes?.post_short_description,
      image: e?.attributes?.post_thumb?.data?.attributes?.url ?? '/images/blog/post_0.png',
      slug: e?.attributes?.post_slug,
      date: e?.attributes?.publishedAt ? moment(e?.attributes?.publishedAt).format('DD MMM YYYY') : moment().format('DD MMM YYYY')
    };
  }) : [];

  const handleLoadMore = () => {
    setLoadMoreBtn(false);
  };

  return (
    <>
      <NextSeo
        title={metaTitle}
        description={metaDesc}
        openGraph={{
          title: `${metaTitle}`,
          description: `${metaDesc}`,
          images: [
            {
              url: `${metaImg}`,
            }
          ]
        }}
      />
      <PageBanner text="Blog" image={'/images/about/banner-bg.png'} />
      {/* <!-- Blog --> */}
      <section className="relative flex flex-wrap lg:flex-nowrap p-4 lg:p-[50px] xl:p-[100px]">
        <Sidebar postTag={postTag?.postTags?.data} postCategory={postCategory?.postCategories?.data}/>
        <div className="w-full">
          {/* <!-- Page title --> */}
          {/* <!-- Featured Post --> */}
          <News_item data={blog_list} loading={loading}/>

          {/* <!-- Load More --> */}
          {loadMoreBtn && (
            <div className="mt-10 text-center">
              <button
                onClick={handleLoadMore}
                className="bg-primary hover:bg-accent-dark inline-block rounded-full py-3 px-8 text-center font-semibold text-white transition-all"
              >
                Load More
              </button>
            </div>
          )}
        </div>
      </section>
      {/* <!-- end blog --> */}
    </>
  );
};

export default Blog;
